import styled from "styled-components";
import { media } from "../../globalStyles";

export const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  height: auto;
  background-color: #0f1923ff;
  border: 4.5px solid #081019ff;
  ${media.mobile} {
    width: 90%;
  }
  ${media.tablet} {
    width: 80%;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 25px 0px;
  width: 100%;

  form {
    width: 100%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  .resetButton {
    margin-top: 15px;
    width: 100px;
  }
  ${media.mobile} {
    align-items: flex-start !important;
    .resetButton {
      margin-left: 25px;
    }
  }
`;

export const LabelBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  flex: 1;
  h2 {
    margin-top: 20px;
    font-size: 16px !important;
  }
  ${media.mobile} {
    display: none;
  }
`;

export const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1.8;
  ${media.mobile} {
    margin-left: 10px;
    width: 100%;
  }
`;

export const MobileLabel = styled.h2`
  margin-top: 20px;
  font-size: 14px !important;
  font-weight: 300;
  ${media.tablet} {
    display: none;
  }
  ${media.desktop} {
    display: none;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  gap: 20px;
  ${media.mobile} {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;
    margin-left: 15px;
  }
`;

export const InputLabel = styled.h2`
  font-size: 15px !important;
  display: flex;
  justify-content: flex-end;
  font-weight: 300;
`;

export const Input = styled.input`
  width: 70%;
  background-color: whitesmoke;
  height: 30px;
  padding: 6px;
  border: none;
  font-style: italic;
  margin-top: 20px;
  &:focus {
    outline-color: rgb(55, 72, 90);
    outline-style: solid;
    outline-width: 3px;
  }
  ${media.mobile} {
    width: 90%;
    margin-top: 8px !important;
  }
  ${media.tablet} {
    width: 80%;
  }
`;

export const Error = styled.p`
  color: darkorange;
`;
